import unescape from 'lodash/unescape';

const vendorTextReplacer = (text) => {
    return unescape(text);
}

export default vendorTextReplacer;